import { UploadFile } from 'antd';

function extractUploadBlob(file: UploadFile): Blob | undefined {
  const originFile = file.originFileObj;

  if (originFile instanceof Blob) {
    return originFile;
  }

  if (file instanceof Blob) {
    return file;
  }

  return undefined;
}

export function appendDossierFormDataDocuments(
  files: UploadFile[] | undefined,
  formData: FormData,
  prefix: string[],
) {
  if (!files?.length) {
    return;
  }

  files
    .filter(({ url }: UploadFile) => !url) // Ignorer les fichiers déjà uploadés
    .forEach((file: UploadFile) => {
      // Comme il n'est pas possible de donner des noms de champs dynamiques pour les fichiers,
      // on concatène le type et le sous-type de fichier au nom de fichier en utilisant des ***
      // (qui sont des caractères inutilisables en temps normal dans un nom de fichier)
      const newName = [...prefix, file.name].join(' *** ');
      const realFile = extractUploadBlob(file);

      if (!realFile) {
        console.error(
          new Error(
            `Impossible de préparer le document "${file.name}" pour l'envoi`,
          ),
        );
        return;
      }

      // fallback MIME type
      const fileType = file.type || realFile.type || 'application/octet-stream';
      const fileContent = realFile.slice(0, realFile.size, fileType);

      // Ajoute le fichier au données du formulaire
      formData.append('documents', fileContent, newName);
    });
}
